import { useParams, useNavigate } from 'react-router-dom';
import POItemViewer from '@/components/Procurement/POItemViewer';
import { ArrowLeft } from 'lucide-react';

const POItemDetailPage = () => {
  const { poId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0f24] to-[#1e2240] text-white p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-cyan-400 hover:text-cyan-200 transition"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Dashboard
        </button>

        <h1 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
          Purchase Order #{poId}
        </h1>

        <POItemViewer poId={poId} />
      </div>
    </div>
  );
};

export default POItemDetailPage;
